import React,{useState} from "react";
import { List, ListItem, Collapse,Typography,
   ListItemText, Divider,
   Tooltip, } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import {findNumberCad} from '../funciones/FindNumber'
import axios from 'axios';
import qs from 'qs';
import { ErrorGeneral,llamadaApiToken } from '../funciones/ClienteAxios';

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
    "&:hover": {
      backgroundColor:theme.palette.primary.dark
    },
   "&.Mui-selected": {
      backgroundColor:theme.palette.primary.dark
    } 
  },

  nested2: {
    paddingLeft: theme.spacing(6),
    "&:hover": {
      backgroundColor:theme.palette.primary.dark
    },
   "&.Mui-selected": {
      backgroundColor:theme.palette.primary.dark
    } 
  },
 
}));

const Listas = ({funcionAbrir}) => {
  let history = useHistory();
  const classes = useStyles();  
  const source = axios.CancelToken.source();      
  const Dispvo = localStorage.getItem('Dispvo') ;    
  const auxnvl = localStorage.getItem("Tipo");
  const cadena = localStorage.getItem("Operacion")+"|";
  const nvl = auxnvl !== null && parseInt(auxnvl) !== 0 ? parseInt(auxnvl):0
  const auxDispV = Dispvo && Dispvo.length >= 12 ? Dispvo:'w8rf51v21dsd2cs'    
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [mostrarUsu, setMostrarUsu] = useState(false);
  const [verTipoUsu, setVerTipoUsu] = useState(false);
  const [listTooltip, setListTooltip] = useState([]);
  const[usrID,setUsrId]=  useState(0);
  const[usrTipo,setUsrTipo]= useState(0);
  const [selectedIndex, setSelectedIndex] = useState("");
  
  
  React.useEffect(() => {

    const auxOpera = localStorage.getItem("Operacion");
    
    const usuID = localStorage.getItem('UsuId');
    let aux1=usuID!== null && parseInt(usuID) !== 0 ? parseInt(usuID):0
    setUsrId(aux1)
    let aux2=nvl!== null && parseInt(nvl) !== 0 ? parseInt(nvl):0
    setUsrTipo(aux2)
    if (nvl !== null && parseInt(nvl) !== 2) {
      setVerTipoUsu(true);
    } else {
      setVerTipoUsu(false);
    }

    let auxValida = false;
    if (auxOpera.indexOf("0") !== -1) {
      auxValida = true;
    }
    if (!auxValida && auxOpera.indexOf("1") !== -1) {
      auxValida = true;
    }
    if (!auxValida && auxOpera.indexOf("2") !== -1) {
      auxValida = true;
    }
    if (!auxValida && auxOpera.indexOf("3") !== -1) {
      auxValida = true;
    }
    /* if (auxValida) 
      { setMostrarUsu(true)
      } 
      else 
      { setMostrarUsu(false)
      } */
    if (parseInt(nvl) !== 2) {
      setMostrarUsu(true);
    } else {
      setMostrarUsu(false);
    }

    getListMuni()

  }, []);

  function getListMuni(auxEdo,tipo)  {            
    const url= `/sistema/menu`;                            
    const data = qs.stringify({                                                          
      idDispositivo:auxDispV,
    });
                
    function respuesta (aux) 
    {  if (aux[0].Id != -1) 
      { setListTooltip(aux)           
      }        
    }
    llamadaApiToken(data, url, respuesta, ErrorGeneral, history, source);
  };

  const cambiar = (opcion) => {
    if (opcion === 1) 
    { setOpen(!open);
    } 
    else{
      if (opcion === 2) 
      { setOpen2(!open2);
      } 
      else{
        if (opcion === 3) 
        { setOpen3(!open3);
        } 
        else{
          if (opcion === 4) 
          { setOpen4(!open4);
          }
        }
      }
    }
  };

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  const nuevaVentana = (elLink) => {
    //funcionAbrir()
    setSelectedIndex(elLink);
    history.push(elLink);
  };

  /* const contacto=(e)=> {
    e.preventDefault()        
  } */

  const ItemLista = (link, descripcion, orden) => {
    const filtro = listTooltip.filter((objeto)=> objeto.Ord  === orden)
    const txtTooltip =filtro.length !== 0 ? filtro[0].Descr : ""
    return (
    <ListItem button className={classes.nested}
      onClick={() => nuevaVentana(link)}
      selected={selectedIndex === link}    
    >
      <Tooltip title={txtTooltip} >
      <ListItemText
        secondary={
          <Typography variant="body" style={{ color: "white" }}>
            {descripcion}
          </Typography>
        }
      />
      </Tooltip>
    </ListItem>
    );
  };  

  const ItemLista2 = (link, descripcion, orden) => {
    const filtro = listTooltip.filter((objeto)=> objeto.Ord  === orden)
    const txtTooltip =filtro.length !== 0 ? filtro[0].Descr : ""
    return (
    <ListItem button className={classes.nested2}
      onClick={() => nuevaVentana(link)}
      selected={selectedIndex === link}    
    >
      <Tooltip title={txtTooltip} >
      <ListItemText
        secondary={
          <Typography variant="body" style={{ color: "white" }}>
            {descripcion}
          </Typography>
        }
      />
      </Tooltip>
    </ListItem>
    );
  }; 

  return (
  <div>
    <List component="nav">
      <ListItem button onClick={() => cambiar(1)}>
        <ListItemText primary="Menu" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {/*  verTipoUsu && usrTipo !== 7  && externo ? ItemLista("/inicio", "Inicio") : null */}
          {/* findNumberCad('|4|',cadena) ?ItemLista("/sondeo", "Sondeo", 0):null */}
          {/* findNumberCad('|4|',cadena) ?ItemLista("/lista-promovido", "Encuestas", 0):null */}
          {/* findNumberCad('|4|',cadena) ?ItemLista("/lista-x-subdistrito", "Encuesta por Subdistrito", 0):null */}
          {/*   usrID === 1 ||  nvl === 1 || findNumberCad('|4|',cadena)? ItemLista("/lista-publico", "Público Cochalas", 1) : null  */} 
          {/*  usrTipo !== 7 && externo ? ItemLista("/lista-promovido", "Promovidos"): */null}
          { /* usrTipo === 7 && externo ? ItemLista("/perfil-externo", "Promovidos"):null */}
          { /* (usrID === 1 ||  (findNumberCad('|10|',cadena)) ? ItemLista("/registro-previo", "Militante") : null  */}
          {/* (usrID === 1 ||   findNumberCad('|34|',cadena)) ? ItemLista("/solicitudes-atencion", "Solicitudes de Atención", 2) :null   */}
          {/* (usrID === 1 ||   findNumberCad('|40|',cadena)) ? ItemLista("/asistencia", "Asistencia",3) :null  */ }

          {  (usrID === 1 ||  findNumberCad('|3|',cadena))? ItemLista("/lista-usuario", "Usuarios", 4) : null }
          {/*  (usrID === 1 ||  findNumberCad('|13|',cadena)) ? ItemLista("/apoyo", "Apoyos") :null   */}
          {/* <ListItem button onClick={() => cambiar(3)} style={{marginLeft:"1rem"}}>
            <ListItemText primary="Recorridos" />
            {open3 ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={open3} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {(usrID === 1) ||usrID === 2  ? ItemLista2("/recorrido", "Listado",5) :null    }
              {usrID === 1  || usrID === 2 ? ItemLista2("/mapa-recorrido", "Mapas",6) :null    }
            </List>
          </Collapse> */}
          {usrID === 1  || findNumberCad('|16|',cadena) ? ItemLista("/estructura", "Lideres",6) :null    }
          {/* usrID === 1  || findNumberCad('|16|',cadena) ? ItemLista("/otb-recintos", "OTB y Recintos",6) :null     */}
          {/* usrID === 1 || findNumberCad('|46|',cadena)  ? ItemLista("/mapa-ruta", "Rutas",6) :null    */ }
          {/* <ListItem button onClick={() => cambiar(2)} style={{marginLeft:"1rem"}}>
            <ListItemText primary="Minutas" />
            {open2 ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={open2} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {usrID === 1  || findNumberCad('|16|',cadena) ? ItemLista2("/minutas-activ", "Actividades",6) :null    }
              {usrID === 1  || findNumberCad('|16|',cadena) ? ItemLista2("/minutas-solic", "Solicitudes",6) :null    }
            </List>
          </Collapse> */}
          { ItemLista("/publico", "Público",1) }
          {  ItemLista("/ios-listado", "Listado IOS",1)   }
          { nvl  === 1 ? ItemLista("/lista-evento", "Eventos", 4) :null }
          {/*   usrID === 1 ||  findNumberCad('|24|',cadena) ? ItemLista("/notificacion", "Notificación",7) : null  */}
          {/*   (usrID === 1 ||findNumberCad('|28|',cadena))? ItemLista("/mapa-secc", "Mapa Secciones",8) : null  */}
          
        </List>
        <Divider />        
      <List component="div" disablePadding>            
        {/*   findNumberCad('|20|',cadena) || usrID===1  ? ItemLista("/incidencia", "Incidencias") : null    */}
        { /* (usrID === 1 ||  nvl  === 1 ||  nvl  >= 7 )  ? ItemLista("/estafeta", "Estafeta") : null  */}
        { /* (usrID === 1 ||  findNumberCad('|18|',cadena)) ? ItemLista("/comite", "Comités") : null */  }
        {/* usrID === 1  || findNumberCad('|29|',cadena) ? ItemLista("/prep", "Votación") : null   */ }
        { /* usrID === 1 ||  nvl === 1 ||  nvl === 7 ||nvl === 9 ||nvl === 10  ? ItemLista("/organizacion", "Organización") : null   */}
        { /*   usrID === 1 ||  findNumberCad('|31|',cadena)? ItemLista("/carga-total", "Carga de Trabajo") : null   */ } 
        {  /*  usrID === 1 ||  findNumberCad('|32|',cadena)   ? ItemLista("/avance-general", "Avance General",9) : null   */ }  
        {/* usrID === 1 || usrID === 2? ItemLista("/afiliado", "Afiliado", 10) : null   */}  
        {  /*  usrID === 1 ||  findNumberCad('|32|',cadena)   ? ItemLista("/avance-solicitud", "Avance Solicitud") : null   */ }      
        {/*  usrID === 1 ||  findNumberCad('|33|',cadena)? ItemLista("/limpiar-cache", "Cache") : null */  }   
        { /*  (usrID === 1 ||  findNumberCad('|45|',cadena))? ItemLista("/reporte-encuesta", "Reporte Encuesta", 0) : null */ }   
        { /*  (usrID === 1 ||  findNumberCad('|42|',cadena))? ItemLista("/reporte-avance", "Reporte Avance", 0) : null */ }   
        { /*  (usrID === 1)? ItemLista("/reporte-encuesta-individual", "Reporte Encuesta Individual", 0) : null */ }   
      </List> 
      </Collapse>
             
      {/*<ListItem button onClick={contacto} >                    
          <ListItemText  
            secondary={<Typography variant="body2" style={{ color: 'white' }}>
            Contacto</Typography>}
          />                    
      </ListItem> */}
    </List>
  </div>
  );
};

export default Listas;
